/**
 * Validação de Proposta Completa
 * Verifica se todas as linhas da proposta têm plano selecionado
 */

import { LinhaComposicao, ComposicaoProposta } from '@/constants/planosCNPJ';

export interface ValidacaoPropostaResult {
  valida: boolean;
  linhasIncompletas: { indice: number; tipo: string; numero: string }[];
  mensagem: string;
  totalLinhas: number;
  linhasComPlano: number;
}

/**
 * Valida se a proposta está completa (todas as linhas têm plano selecionado)
 */
export function validarPropostaCompleta(
  composicao: ComposicaoProposta | null | undefined
): ValidacaoPropostaResult {
  // Se não tem composição, considera válida (pedido sem proposta)
  if (!composicao || !composicao.linhas || composicao.linhas.length === 0) {
    return {
      valida: true,
      linhasIncompletas: [],
      mensagem: 'Proposta vazia - pedido será criado sem itens',
      totalLinhas: 0,
      linhasComPlano: 0,
    };
  }

  const linhasIncompletas: { indice: number; tipo: string; numero: string }[] = [];

  composicao.linhas.forEach((linha, indice) => {
    // Linha incompleta = sem planoId ou sem plano. O tipo de chip NÃO entra
    // aqui: ele se escolhe no pedido, não na proposta (Douglas 22/09/2026).
    if (!linha.planoId || !linha.plano) {
      linhasIncompletas.push({
        indice: indice + 1, // 1-indexed para exibição
        tipo: linha.tipo,
        numero: linha.numero || `Linha ${indice + 1}`,
      });
    }
  });

  const totalLinhas = composicao.linhas.length;
  const linhasComPlano = totalLinhas - linhasIncompletas.length;
  const valida = linhasIncompletas.length === 0;

  let mensagem = '';
  if (valida) {
    mensagem = `Proposta completa com ${totalLinhas} linha(s)`;
  } else {
    const detalhes = linhasIncompletas
      .map(l => `${l.tipo}: ${l.numero}`)
      .join(', ');
    mensagem = `${linhasIncompletas.length} linha(s) sem plano: ${detalhes}`;
  }

  return {
    valida,
    linhasIncompletas,
    mensagem,
    totalLinhas,
    linhasComPlano,
  };
}

/**
 * Verifica se um lead tem proposta e se ela está completa
 */
export function verificarPropostaLead(lead: {
  proposta_composicao_cnpj?: ComposicaoProposta | null;
}): ValidacaoPropostaResult {
  return validarPropostaCompleta(lead.proposta_composicao_cnpj);
}
